module.exports = __webpack_public_path__ + "static/media/choithramsLayerTwo.ecbc5770.png";